import { BaseOption } from './base-option';

export class AdjustmentEffectiveness extends BaseOption { }
